import React from 'react';
import Box from '@amzn/awsui-components-console/box';
import Container from '@amzn/awsui-components-console/container';
import Header from '@amzn/awsui-components-console/header';
import { useTranslation } from 'src/i18n/shim/useTranslation';

interface DescriptionPanelProps {
  /**
   * The group's description. Optional because describeStringGroup may return a
   * group with none; the panel renders an em-dash placeholder in that case
   * rather than being hidden, so the section is a stable landmark on the page.
   */
  description?: string;
}

const NO_DESCRIPTION = '—';

/**
 * Read-only description section for the string group detail page.
 *
 * Mirrors the string detail page's Source Text section (a headered Container
 * with a labelled value block) but is deliberately display-only: unlike
 * SourceTextPanel there is no Edit action here. Group-level edits, including the
 * description, are made through the Edit Group modal, so this panel never offers
 * its own edit affordance.
 */
const DescriptionPanel: React.FC<DescriptionPanelProps> = ({ description }) => {
  const { t } = useTranslation();

  return (
    <Container header={<Header>{t('sgd-description')}</Header>}>
      <Box variant="p" data-testid="group-description">
        {description?.trim() ? description : NO_DESCRIPTION}
      </Box>
    </Container>
  );
};

export default DescriptionPanel;
